const recharge = () => import('@/views/recharge/recharge');

export default [
  {
    path: '/recharge',
    component: recharge,
    meta: [
      {
        name: '首页',
        url: './order-list',
      },
      {
        name: '充值优惠',
        url: '',
      },
    ]
  }
]
